<form (submit)="clickValidateButton()">
  <div class="row field">
    <div class="col-4">
      <label class="field-label" translate>T_BO_MODAL_COUNTRY_NAME</label>
    </div>
    <div class="col-6 offset-2 text-start">
      <span>{{countryName}}</span>
    </div>
  </div>
  <div class="row field">
    <div class="col-4">
      <label class="field-label" translate>T_BO_MODAL_LANGUAGE</label>
    </div>
    <div class="col-6 offset-2">
      <select class="form-select language-width" (change)="selectLanguageCode($event.target.value)">
        <option *ngFor="let language of languages" [value]="language.code">
          {{language.language +' ('+language.code.toUpperCase()+')'}}
        </option>
      </select>
    </div>
  </div>
  <div class="row button-margin">
    <div class="col-3 offset-6">
      <button type="button" class="btn btn-default-white-background" (click)="cancelButton()" translate>T_BUTTON_CANCEL</button>
    </div>
    <div class="col-3">
      <button type="submit" class="btn btn-default-white-background" translate>T_VALIDATE</button>
    </div>
  </div>
</form>
